webpackJsonp([19,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _shared = __webpack_require__(10);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _userServices = __webpack_require__(214);
	
	var _userServices2 = _interopRequireDefault(_userServices);
	
	var _formValidator = __webpack_require__(24);
	
	var _formValidator2 = _interopRequireDefault(_formValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by jv on 17/07/2017.
	 */
	//js
	var log = __webpack_require__(5)();
	
	
	//Styles
	__webpack_require__(774);
	
	$(function () {
	  _shared2.default.init();
	
	  ResetPasswordPage.init();
	});
	
	var ResetPasswordPage = {};
	
	(function (ResetPasswordPage) {
	  var resetPasswordFormValidator = void 0;
	
	  ResetPasswordPage.init = function () {
	    $("#page-title").text(_languageManager2.default.getValueForKey("reset_password.title"));
	
	    setUpForm();
	    setUpEventListeners();
	  };
	
	  function setUpForm() {
	    resetPasswordFormValidator = new _formValidator2.default({
	      selector: "#reset-password-form",
	      validateOnChange: true,
	      rules: {
	        email: {
	          required: false,
	          validator: function validator(value) {
	            return !_utils2.default.isNullOrEmpty(value) && value.trim() !== "";
	          }
	        }
	      }
	    });
	  }
	
	  function setUpEventListeners() {
	    $("#reset-password-btn").off("click").on("click", function (e) {
	      requestPasswordReset();
	    });
	  }
	
	  function requestPasswordReset() {
	    if (_utils2.default.isNull(resetPasswordFormValidator)) return;
	
	    var $formFeedback = $("#reset-password-form").find(".form-feedback").empty().removeClass("form-feedback__valid");
	
	    var formData = resetPasswordFormValidator.getFormData();
	    var email = formData.email;
	
	    if (resetPasswordFormValidator.validate()) {
	      var $resetPasswordBtn = $("#reset-password-btn");
	      $resetPasswordBtn.prop("disable", true).addClass("btn-loading");
	
	      _userServices2.default.requestPasswordReset(email).then(function (data) {
	        log.info("Successfully requested password reset email");
	        $formFeedback.text(_languageManager2.default.getValueForKey("reset_password.result.success.text")).addClass("form-feedback__valid");
	      }).catch(function (err) {
	        log.error("Failed to request password reset email");
	
	        if (err.code === "E91489") {
	          $formFeedback.text(_languageManager2.default.getValueForKey("reset_password.result.fail.unknown_user.text"));
	        } else {
	          $formFeedback.text(_languageManager2.default.getValueForKey("reset_password.result.fail.unexpected.text"));
	        }
	      }).finally(function () {
	        $resetPasswordBtn.prop("disable", false).removeClass("btn-loading");
	      });
	    }
	  }
	})(ResetPasswordPage);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 12
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 11;


/***/ }),

/***/ 774:
47

});


// WEBPACK FOOTER //
// js/reset-password.96c3e02dc7f741191ae3.js